import Vue from "vue";
import Router from "vue-router"; 

Vue.use(Router);
let router = [

  /* 委托代征相关页面 */ 
  {
    path: '/qrcodeLoginTask', // 中性登录页,登录成功跳任务大厅
    name: 'qrcodeLoginTask',
    component: resolve =>
      require(['../views/Entrust/qrcodeLoginTask/index.vue'], resolve)
  },
  {
    path: '/taskPageNew', // 任务大厅页面,点击跳任务页/task
    name: 'taskPageNew',
    component: resolve =>
      require(['../views/Entrust/taskPageNew/index.vue'], resolve)
  },
  //-- 扫码登录接单入口
  {
    path: "/qrcodeLogin", // 登录页面
    name: "qrcodeLogin",
    component: resolve =>
      require(["../views/Entrust/qrcodeLogin/index.vue"], resolve)
  },
  {
    path: "/task", // 任务详情页
    name: "task",
    component: resolve => require(["../views/Entrust/task/index.vue"], resolve)
  },
  {
    path: "/success", // 成功页面(包括认证成功与接单成功)
    name: "success",
    component: resolve =>
      require(["../views/Entrust/success/index.vue"], resolve)
  },
  {
    path: "/weiAuthInfo", // 实名未认证页面（登录之后并且未实名的时候）
    name: "weiAuthInfo",
    component: resolve =>
      require(["../views/Entrust/weiAuthInfo/index.vue"], resolve)
  },
  //-- 扫码免登接单入口
  {
    path: "/qrcodeh5case2", // 实名认证页面 2
    name: "qrcodeh5case2",
    component: resolve =>
      require(["../views/Entrust/qrcodeh5case2/index.vue"], resolve)
  },
  {
    path: "/qrcodeh5case2/wxApplyIndex", // wx环境内打开的中间页 
    name: "wxApplyIndex",
    component: resolve =>
      require(["../views/Entrust/qrcodeh5case2/wxApplyIndex.vue"], resolve)
  },
  {
    path: "/qrcodeh5case2/wxApply", // wx环境 实名认证页面 2
    name: "wxApply",
    component: resolve =>
      require(["../views/Entrust/qrcodeh5case2/wxApply.vue"], resolve)
  },
  {
    path: "/taskcase2", // 任务详情2
    name: "taskcase2",
    component: resolve =>
      require(["../views/Entrust/taskcase2/index.vue"], resolve)
  },
  {
    path: "/taskcase2v2", // 任务详情2 微信环境
    name: "taskcase2v2",
    component: resolve =>
      require(["../views/Entrust/taskcase2/indexv2.vue"], resolve)
  },
  {
    path: '/taskFaceAuth', // 委托代征 接单人脸认证页面
    name: 'taskFaceAuth',
    component: (resolve) => require(['../views/Entrust/taskFaceAuth/index.vue'], resolve)
  },
  {
    path: '/taskFaceAuthResult', // 委托代征 接单人脸认证结果页面
    name: 'taskFaceAuthResult',
    component: (resolve) => require(['../views/Entrust/taskFaceAuth/result.vue'], resolve)
  },
  {
    path: "/faceAuth2", // 人脸认证页面
    name: "faceAuth2",
    component: resolve => require(["../views/faceAuth/index.vue"], resolve)
  },
  {
    path: "/successcase2", // 成功(包括认证成功与接单成功)2免登和短信签
    name: "successcase2",
    component: resolve => require(["../views/successcase2/index.vue"], resolve)
  },
  //-- 短信接单入口
  {
    path: "/qrcodeh5case2/sms", // h5短信接单 
    name: "wxApply",
    component: resolve => require(["../views/Entrust/sms/index.vue"], resolve)
  },
  //-- 三方服务 扫码接单
  {
    path: '/thirdTask', // 任务详情页
    name: 'thirdTask',
    component: (resolve) => require(['../views/ThirdService/task.vue'], resolve)
  },
  {
    path: '/thirdCertify', // 实名认证
    name: 'thirdCertify',
    component: (resolve) => require(['../views/ThirdService/certify.vue'], resolve)
  },
  {
    path: '/wxThirdCertify', // 实名认证 微信环境
    name: 'wxThirdCertify',
    component: (resolve) => require(['../views/ThirdService/wxCertify.vue'], resolve)
  },
  {
    path: '/thirdSuccess', // 接单成功
    name: 'thirdSuccess',
    component: (resolve) => require(['../views/ThirdService/success.vue'], resolve)
  },
  {
    path: "/thirdFaceResult", // 人脸认证结果页面
    name: "thirdFaceResult",
    component: resolve =>
      require(["../views/ThirdService/faceResult.vue"], resolve)
  },
  
  
  // 三方服务万事云 连续劳务 
  {
    path: "/thirdUpInfo", // 收集用户身份证等信息
    name: "thirdUpInfo",
    component: resolve =>
      require(["../views/Entrust/thirdService/upInfo.vue"], resolve)
  },
  {
    path: "/WtaskInfo", // 任务详情页
    name: "WtaskInfo",
    component: resolve =>
      require(["../views/Entrust/thirdService/task.vue"], resolve)
  },
  {
    path: "/Wsuccess", // 接单成功
    name: "Wsuccess",
    component: resolve =>
      require(["../views/Entrust/thirdService/success.vue"], resolve)
  },


  /* 自然人代开相关页面 */
  {
    path: "/qrcodeLoginNatual", // 自然人代开 二维码登录页面
    name: "qrcodeLoginNatual",
    component: resolve =>
      require(["../views/NatualPeople/qrcodeLoginNatual/index.vue"], resolve)
  },
  {
    path: "/taskNatual", // 自然人代开 任务详情页
    name: "taskNatual",
    component: resolve =>
      require(["../views/NatualPeople/taskNatual/index.vue"], resolve)
  },
  {
    path: "/successNatual", // 自然人代开 成功(包括认证成功与接单成功)登录
    name: "successNatual",
    component: resolve =>
      require(["../views/NatualPeople/successNatual/index.vue"], resolve)
  },
  {
    path: "/weiAuthInfoNatual", // 自然人代开 实名未认证页面（登录之后并且未实名的时候）
    name: "weiAuthInfoNatual",
    component: resolve =>
      require(["../views/NatualPeople/weiAuthInfoNatual/index.vue"], resolve)
  },
  {
    path: "/qrcodeh5case2Natual", // 自然人代开 扫码免登接单
    name: "qrcodeh5case2Natual",
    component: resolve =>
      require(["../views/NatualPeople/qrcodeh5case2Natual/index.vue"], resolve)
  },
  {
    path: "/qrcodeh5case2Natual/wxApplyNatual", // 自然人代开 wx h5接单
    name: "wxApplyNatual",
    component: resolve =>
      require([
        "../views/NatualPeople/qrcodeh5case2Natual/wxApply.vue"
      ], resolve)
  },
  {
    path: "/qrcodeh5case2Natual/wxApplyIndexNatual", // wx h5首页
    name: "wxApplyIndexNatual",
    component: resolve =>
      require([
        "../views/NatualPeople/qrcodeh5case2Natual/wxApplyIndex.vue"
      ], resolve)
  },
  {
    path: "/taskcase2Natual", // 自然人代开 任务详情2
    name: "taskcase2Natual",
    component: resolve =>
      require(["../views/NatualPeople/taskcase2Natual/index.vue"], resolve)
  },
  {
    path: "/taskcase2v2Natual", // 自然人代开 任务详情2 微信环境
    name: "taskcase2v2Natual",
    component: resolve =>
      require(["../views/NatualPeople/taskcase2Natual/indexv2.vue"], resolve)
  },
  {
    path: "/successcase2Natual", // 自然人代开 成功(包括认证成功与接单成功)2免登
    name: "successcase2Natual",
    component: resolve =>
      require(["../views/NatualPeople/successcase2Natual/index.vue"], resolve)
  },
  {
    path: "/qrcodeh5case2Natual/smsNatual", // h5短信接单
    name: "smsNatual",
    component: resolve =>
      require(["../views/NatualPeople/qrcodeh5case2Natual/sms.vue"], resolve)
  },
  {
    path: "/404", // 系统维护中
    name: "404",
    component: resolve =>
      require(["../views/NatualPeople/404/index.vue"], resolve)
  },
  {
    path: "/compNull", // 企业未进件
    name: "compNull",
    component: resolve =>
      require(["../views/NatualPeople/compNull/index.vue"], resolve)
  },
  /* 自然人代开
   * 收集用户信息后跳转海南活体认证
   */
  {
    path: "/idcardupload", // 身份证上传
    name: "idcardupload",
    component: resolve => require(["../views/idcardUpload/index.vue"], resolve)
  },
  {
    path: "/idcardup", // 身份证上传, 有身份绑定弹窗提示
    name: "idcardup",
    component: resolve =>
      require(["../views/idcardUpload/indexNew.vue"], resolve)
  },
  {
    path: "/offline/login", // 短信登录
    name: "idcardup",
    component: resolve => require(["../views/idcardUpload/login.vue"], resolve)
  },
  {
    path: "/offline/task", // 任务详情
    name: "idcardup",
    component: resolve => require(["../views/idcardUpload/task.vue"], resolve)
  },
  {
    path: "/faceinfo", // 海南活体loading中间页
    name: "faceinfo",
    component: resolve =>
      require(["../views/NatualPeople/faceinfo/index.vue"], resolve)
  },
  {
    path: '/faceinfoOffline', // 海南活体loading中间页 线下
    name: 'faceinfoOffline',
    component: (resolve) => require(['../views/NatualPeople/faceinfo/offLine.vue'], resolve)
  },
  {
    path: "/zrrpay", // 自然人小程序税金支付loading中间页
    name: "zrrpay",
    component: resolve =>
      require(["../views/NatualPeople/zrrpay/index.vue"], resolve)
  },
  /* 自然人代开 海南活体认证 工具*/
  {
    path: '/htAuthUp', // 身份证上传
    name: 'htAuthUp',
    component: (resolve) => require(['../views/NatualPeople/htAuth/upload.vue'], resolve)
  },
  {
    path: '/wxhtAuthUp', // 身份证上传(微信环境)
    name: 'wxhtAuthUp',
    component: (resolve) => require(['../views/NatualPeople/htAuth/wxUpload.vue'], resolve)
  },
  {
    path: '/htAuthResult', // 认证结果 
    name: 'htauthResult',
    component: (resolve) => require(['../views/NatualPeople/htAuth/result.vue'], resolve)
  },

  /* 税金支付 */
  {
    path: "/taxpay",
    name: "taxpay",
    component: resolve => require(["../views/taxPay/index.vue"], resolve)
  },
  {
    path: "/taxpaylist",
    name: "taxpaylist",
    component: resolve => require(["../views/taxPay/payList.vue"], resolve)
  },
  {
    path: "/paySuccess",
    name: "paySuccess",
    component: resolve => require(["../views/taxPay/paySuccess.vue"], resolve)
  },


  /* 劳务相关页面 */
  {
    path: "/qrcodeLoginLabour", // 劳务 二维码登录页面
    name: "qrcodeLoginLabour",
    component: resolve =>
      require(["../views/Labour/qrcodeLoginLabour/index.vue"], resolve)
  },
  {
    path: "/taskLabour", // 劳务 任务详情页
    name: "taskLabour",
    component: resolve =>
      require(["../views/Labour/taskLabour/index.vue"], resolve)
  },
  {
    path: "/successLabour", // 劳务 成功(包括认证成功与接单成功)登录
    name: "successLabour",
    component: resolve =>
      require(["../views/Labour/successLabour/index.vue"], resolve)
  },
  {
    path: "/weiAuthInfoLabour", // 劳务 实名未认证页面（登录之后并且未实名的时候）
    name: "weiAuthInfoLabour",
    component: resolve =>
      require(["../views/Labour/weiAuthInfoLabour/index.vue"], resolve)
  },
  {
    path: "/qrcodeh5case2Labour", // 劳务 扫码免登接单
    name: "qrcodeh5case2Labour",
    component: resolve =>
      require(["../views/Labour/qrcodeh5case2Labour/index.vue"], resolve)
  },
  {
    path: "/qrcodeh5case2Labour/wxApplyLabour", // 劳务 wx h5接单
    name: "wxApplyLabour",
    component: resolve =>
      require([
        "../views/Labour/qrcodeh5case2Labour/wxApplyLabour.vue"
      ], resolve)
  },
  {
    path: "/qrcodeh5case2Labour/wxApplyIndexLabour", // wx h5首页
    name: "wxApplyIndexLabour",
    component: resolve =>
      require([
        "../views/Labour/qrcodeh5case2Labour/wxApplyIndexLabour.vue"
      ], resolve)
  },
  {
    path: "/taskcase2Labour", // 劳务 任务详情2
    name: "taskcase2Labour",
    component: resolve =>
      require(["../views/Labour/taskcase2Labour/index.vue"], resolve)
  },
  {
    path: "/taskcase2v2Labour", // 劳务 任务详情2 微信环境
    name: "taskcase2v2Labour",
    component: resolve =>
      require(["../views/Labour/taskcase2v2Labour/index.vue"], resolve)
  },
  {
    path: "/successcase2Labour", // 劳务 成功(包括认证成功与接单成功)2免登
    name: "successcase2Labour",
    component: resolve =>
      require(["../views/Labour/successcase2Labour/index.vue"], resolve)
  },


  /* 其他页面 */ 
  {
    path: "/appLogin", // app登录页面
    name: "appLogin",
    component: resolve => require(["../views/appLogin/index.vue"], resolve)
  },
  {
    path: "/nestedContract", // H5外链
    name: "nestedContract",
    component: resolve =>
      require(["../views/nestedContract/index.vue"], resolve)
  },
  {
    path: "/showOpenId", // 杰哥展示二维码
    name: "showOpenId",
    component: resolve => require(["../views/showOpenId/index.vue"], resolve)
  },
  {
    path: "/successcasewxmatask", // 成功(包括认证成功与接单成功)2
    name: "successcasewxmatask",
    component: resolve => require(["../views/successcase2/index.vue"], resolve)
  },
  // {
  //   path: "/labourCalculator", // 连续劳务计算器
  //   name: "labourCalculator",
  //   component: resolve =>
  //     require(["../views/labourCalculator/index.vue"], resolve)
  // },
  {
    path: "/authInfo", // 实名已经认证页面 (劳务 自然人) 暂无用
    name: "authInfo",
    component: resolve => require(["../views/authInfo/index.vue"], resolve)
  },


  /* 协议展示相关页面 */ 
  // {
  //   path: "/authorizeletter/login", // 委托授权书login
  //   name: "authorizeletterLogin",
  //   component: resolve =>
  //     require(["../views/authorizeletter/login.vue"], resolve)
  // },
  // {
  //   path: "/authorizeletter/supply", // 委托授权书补充
  //   name: "authorizeletterSupply",
  //   component: resolve =>
  //     require(["../views/authorizeletter/supply.vue"], resolve)
  // },
  {
    path: "/gome_share_service_agreement.html", // 委托服务协议
    name: "gome_share_service_agreement",
    component: resolve =>
      require(["../views/agreement/gome_share_service_agreement.vue"], resolve)
  },
  {
    path: "/gome_share_pay_agreement.html", // 委托付款协议
    name: "gome_share_pay_agreement",
    component: resolve =>
      require(["../views/agreement/gome_share_pay_agreement.vue"], resolve)
  },

  
  /* 自助开户 企业认证 */ 
  {
    path: "/certicationChoose",
    name: "certicationChoose",
    component: resolve =>
      require(["../views/openAccount/certicationChoose.vue"], resolve)
  },
  {
    path: "/open/auth", // 开户平台实名认证
    name: "openAuth",
    component: resolve => require(["../views/open/auth.vue"], resolve)
  },
  {
    path: "/open/sign", // 开户平台签约
    name: "openSign",
    component: resolve => require(["../views/open/signview.vue"], resolve)
  },
  {
    path: "/open/signContract", // 开户平台签约
    name: "signContract",
    component: resolve => require(["../views/open/signContract.vue"], resolve)
  },
  {
    path: "/open/signzp", // 开户平台签约
    name: "openSignZp",
    component: resolve => require(["../views/open/signzp.vue"], resolve)
  },
  {
    path: "/open/signpp", // 开户平台签约
    name: "openSignPp",
    component: resolve => require(["../views/open/signpp.vue"], resolve)
  },
  {
    path: "/open/success", // 开户平台签约
    name: "openSignSuccess",
    component: resolve => require(["../views/open/signSuccess.vue"], resolve)
  },
  {
    path: "/pdfPage", // 展示pdf预览也
    name: "pdfPage",
    component: resolve => require(["@/components/pdfPage.vue"], resolve)
  },
  {
    path: "/incomePage", // 我的收入
    name: "incomePage",
    component: resolve => require(["../views/incomePage/index.vue"], resolve)
  },
  {
    path: "/incomeDetail", // 我的收入详情页
    name: "incomeDetail",
    component: resolve => require(["../views/incomeDetail/index.vue"], resolve)
  },


  /* 河北自然人代开业务 */
  // {
  //   path: '/hb/qrcodeLogin', // 二维码扫码登录页面
  //   name: 'HBqrcodeLogin',
  //   component: resolve =>
  //     require(['../views/HBnatualPeople/qrcodeLogin/index.vue'], resolve)
  // },
  // {
  //   path: '/hb/taskInfo', // 任务详情页
  //   name: 'HBtaskInfo',
  //   component: resolve =>
  //     require(['../views/HBnatualPeople/taskInfo/index.vue'], resolve)
  // },
  {
    path: '/hb/login', // 开票登录页面
    name: 'HBlogin',
    component: resolve =>
      require(['../views/HBnatualPeople/login/index.vue'], resolve)
  },
  {
    path: '/hb/register', // 税局注册页面
    name: 'HBregister',
    component: resolve =>
      require(['../views/HBnatualPeople/register/index.vue'], resolve)
  },
  {
    path: '/hb/sjLogin', // 税局登录页面
    name: 'HBsjLogin',
    component: resolve =>
      require(['../views/HBnatualPeople/sjLogin/index.vue'], resolve)
  },
  {
    path: '/hb/resetPassword', // 重置密码页面
    name: 'HBresetPassword',
    component: resolve =>
      require(['../views/HBnatualPeople/resetPassword/index.vue'], resolve)
  },
  {
    path: '/hb/apply', // 开票申请页面
    name: 'HBapply',
    component: resolve =>
      require(['../views/HBnatualPeople/apply/index.vue'], resolve)
  },
  {
    path: '/hb/success', // 成功页面
    name: 'HBsuccess',
    component: resolve =>
      require(['../views/HBnatualPeople/success/index.vue'], resolve)
  },
  {
    path: '/hb/agreementGzh', // 自然人代开增值税普通发票合规要求告知函
    name: 'HBagreementGzh',
    component: resolve =>
      require(['../views/HBnatualPeople/agreement/hb_gzh.vue'], resolve)
  },

  /* 湖北自然人代开 恒昌认证 */
  {
    path: "/hub/certification", // 身份证上传页面 四要素
    name: "HuBCertification",
    component: resolve =>
      require(["../views/HuBeiNatualPeople/certification/index.vue"], resolve)
  },
  // {
  //   path: "/hub/step",
  //   name: "HuBStep",
  //   component: resolve =>
  //     require(["../views/HuBeiNatualPeople/step/index.vue"], resolve)
  // },
  {
    path: "/hub/step/auth", // 第一步 活体认证
    name: "HuBStepAuth",
    component: resolve =>
      require(["../views/HuBeiNatualPeople/step/auth.vue"], resolve)
  },
  {
    path: "/hub/step/signInform", // 第二步 告知函
    name: "HuBStepSignInform",
    component: resolve =>
      require(["../views/HuBeiNatualPeople/step/signInform.vue"], resolve)
  },
  {
    path: "/hub/step/letter", // 第三步 委托书
    name: "HuBStepLetter",
    component: resolve =>
      require(["../views/HuBeiNatualPeople/step/letter.vue"], resolve)
  },
  {
    path: "/hub/step/protocol", // 第四步 服务协议
    name: "HuBStepProtocol",
    component: resolve =>
      require(["../views/HuBeiNatualPeople/step/protocol.vue"], resolve)
  },
  {
    path: "/hub/step/settle", // 第五步 结算单
    name: "HuBStepSettle",
    component: resolve =>
      require(["../views/HuBeiNatualPeople/step/settle.vue"], resolve)
  },
  {
    path: "/hub/success",
    name: "HuBSuccess",
    component: resolve =>
      require(["../views/HuBeiNatualPeople/success/index.vue"], resolve)
  },
  // {
  //   path: "/hub/letterList", // 委托书列表
  //   name: "HuBLetterList",
  //   component: resolve =>
  //     require(["../views/HuBeiNatualPeople/letter/index.vue"], resolve)
  // },
  {
    path: "/hub/agreement/signInform", // 阅读告知函
    name: "HuBAgreementSignInform",
    component: resolve =>
      require(["../views/HuBeiNatualPeople/agreement/signInform.vue"], resolve)
  },
  {
    path: "/hub/agreement/letter", // 阅读理委托书
    name: "HuBAgreementLetter",
    component: resolve =>
      require(["../views/HuBeiNatualPeople/agreement/letter.vue"], resolve)
  },
  {
    path: "/hub/agreement/protocol", // 阅读 服务协议
    name: "HuBAgreementProtocol",
    component: resolve =>
      require(["../views/HuBeiNatualPeople/agreement/protocol.vue"], resolve)
  },
  {
    path: "/hub/agreement/protocol-mdh", // 阅读 服务协议(麦的好)
    name: "HuBAgreementProtocolMDH",
    component: resolve =>
      require(["../views/HuBeiNatualPeople/agreement/protocol-mdh.vue"], resolve)
  },
  {
    path: "/hub/agreement/statement", // 阅读 结算单
    name: "HuBAgreementStatement",
    component: resolve =>
      require(["../views/HuBeiNatualPeople/agreement/statement.vue"], resolve)
  },
  {
    path: "/hub/agreement/statement-tjtc", // 阅读 结算单(天津泰创)
    name: "HuBAgreementStatementTJTC",
    component: resolve =>
      require(["../views/HuBeiNatualPeople/agreement/statement-tjtc.vue"], resolve)
  },
  // 非首次签约
  {
    path: "/hub/userInfo", // 身份证正反面
    name: "HuBUserInfo",
    component: resolve =>
      require(["../views/HuBeiNatualPeople/settle/userInfo.vue"], resolve)
  },
  {
    path: "/hub/settleList", // 结算单列表
    name: "HuBSettleList",
    component: resolve =>
      require(["../views/HuBeiNatualPeople/settle/listPage.vue"], resolve)
  },
  {
    path: "/hub/settleAgreement", // 结算单列表
    name: "HuBSettleAgreement",
    component: resolve =>
      require(["../views/HuBeiNatualPeople/settle/settleAgreement.vue"], resolve)
  },
];
export default new Router({
  mode: "history",
  routes: router
});



// WEBPACK FOOTER //
// ./src/router/index.js